import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

export const fetchProducts = () => apiClient.get("/products").then(r => r.data);
export const fetchProduct = (id) => apiClient.get(`/products/${id}`).then(r => r.data);
export const fetchTimeline = () => apiClient.get("/timeline").then(r => r.data);
export const fetchEndorsements = () => apiClient.get("/endorsements").then(r => r.data);
export const fetchRefills = () => apiClient.get("/refills").then(r => r.data);
export const fetchRefill = (id) => apiClient.get(`/refills/${id}`).then(r => r.data);
export const saveConfiguration = (payload) => apiClient.post("/configurations", payload).then(r => r.data);
export const loadConfiguration = (slug) => apiClient.get(`/configurations/${slug}`).then(r => r.data);
export const finderEstimate = (payload) => apiClient.post("/finder/estimate", payload).then(r => r.data);
export const newsletterSignup = (payload) => apiClient.post("/newsletter", payload).then(r => r.data);
export const configureBundle = (payload) => apiClient.post("/configure", payload).then(r => r.data);
export const createCheckout = (payload) => apiClient.post("/payments/checkout", payload).then(r => r.data);
export const paymentStatus = (sid) => apiClient.get(`/payments/status/${sid}`).then(r => r.data);
// Clinic
export const clinicListOrders = () => apiClient.get("/clinics/orders").then(r => r.data);
export const clinicCreateOrder = (payload) => apiClient.post("/clinics/orders", payload).then(r => r.data);
export const clinicGetOrder = (ref) => apiClient.get(`/clinics/orders/${ref}`).then(r => r.data);
export const publicTrackOrder = (ref) => apiClient.get(`/order-track/${ref}`).then(r => r.data);
export const createSubscriptionCheckout = (payload) => apiClient.post("/subscriptions/checkout", payload).then(r => r.data);

export const formatUsd = (cents) =>
  `$${(cents / 100).toFixed(2)}`;
